import type { FC } from 'react';

import { gql } from '@apollo/client';
import { useFeatureFlagBool } from '@modernloop/shared/feature-flag';

import useAuth from 'src/hooks/useAuth';

import { useInterviewerSessionActivityTimeoutQuery } from 'src/interviewer-portal/generated/graphql';

import { isGraphqlPermissionError } from 'src/shared/app/graphqlPermissionError';
import SessionInactivityTimeout from 'src/shared/app/SessionInactivityTimeout';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- used by codegen
const InterviewerSessionActivityTimeoutQuery = gql`
  query InterviewerSessionActivityTimeout {
    thisOrg {
      id
      sessionInactivityTimeout {
        seconds
        nanos
      }
    }
  }
`;

/**
 * Loads the interviewer-portal session timeout from interviewer GraphQL and enforces it when available.
 */
const InterviewerPortalSessionActivityTimeout: FC = () => {
  const enabled = useFeatureFlagBool('SESSION_INACTIVITY_TIMEOUT');
  const { isAuthenticated } = useAuth();

  const { data, error, loading } = useInterviewerSessionActivityTimeoutQuery({
    errorPolicy: 'all',
    skip: !enabled || !isAuthenticated,
  });

  if (!enabled || loading) {
    return null;
  }

  const timeoutDuration = isGraphqlPermissionError(error) ? null : data?.thisOrg?.sessionInactivityTimeout;

  return <SessionInactivityTimeout timeoutDuration={timeoutDuration} />;
};

export default InterviewerPortalSessionActivityTimeout;
